import { errorAIMessage } from '@features/applications';
import { writeWithAIRoute } from '@features/messaging';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation } from 'react-query';

type UseGetAIChatSuggestionProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetAIChatSuggestion = ({
  setErrorText = () => {},
}: UseGetAIChatSuggestionProps) => {
  const { mutate: sendAIPrompt, isLoading: isSendingPromptLoading } =
    useMutation({
      mutationFn: (variables: { prompt: string }) => {
        return axiosInstance
          .post(writeWithAIRoute, variables)
          .then((res) => res.data);
      },
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message ?? errorAIMessage);
        } else {
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorAIMessage);
      },
    });

  return {
    sendAIPrompt,
    isSendingPromptLoading,
  };
};
